<template>
  <el-card class="box-card">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item prop="fileName">
        <el-input v-model="searchInfo.fileName" placeholder="请输入文件名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchInfo.timeNode"
          placeholder="请选择时间节点"
          filterable
          clearable
          @change="getTypeList"
        >
          <el-option
            v-for="item in nodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchInfo.fileTypeId"
          placeholder="请选择文件类型"
          filterable
          clearable
          :disabled="!searchInfo.timeNode"
        >
          <el-option
            v-for="item in typeList"
            :key="item.typeId"
            :label="item.typesName"
            :value="item.typeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="dateRange">
        <el-date-picker
          v-model="searchInfo.dateRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      class="global-table"
      stripe
      :data="tableData"
      v-loading="loading">
      <el-table-column show-overflow-tooltip min-width="120px" label="文件名称" prop="fileName"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="120px" label="文件类型" prop="fileTypeName"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="120px" label="文件备注" prop="comments"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="120px" label="时间节点" prop="timeNode">
        <template v-slot="{ row }">
          <span>{{nodeList[row.timeNode - 1].label}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip min-width="120px" label="上传人员" prop="userName"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="120px" label="上传时间" prop="ctime"></el-table-column>
      <el-table-column label="操作" width="140px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onPreview(row)" v-show="$ButtonShow('preview')">预览</el-button>
          <el-button type="text" @click="onDownload(row)" v-show="$ButtonShow('PFS_DOL_01')">下载</el-button>
          <el-button type="text" @click="onDelete(row.fileId)" v-show="$ButtonShow('PFS_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination
      :total="total"
      :current-page.sync="page"
      :page-size.sync="size"
      @current-change="loadData"
      @size-change="loadData">
    </GlobalPagination>

    <el-dialog :title="previewInfo.title || ''" :append-to-body="true" :visible.sync="showPreview" width='1200px' class="dialog" :close-on-click-modal='false' destroy-on-close>
      <div v-loading="loadingDialog">
        <iframe :src="previewInfo.previewUrl" ref="iframe"></iframe>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import Base64 from '@/utils/base64.min.js'
export default {
  data () {
    return {
      searchInfo: {
        fileName: '',
        timeNode: '',
        fileTypeId: '',
        dateRange: []
      },
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      typeList: [],
      nodeList: [
        {
          label: '项目进场前',
          value: '1'
        },
        {
          label: '施工作业中',
          value: '2'
        },
        {
          label: '验收完成',
          value: '3'
        },
        {
          label: '审计定案',
          value: '4'
        }
      ],
      showPreview: false,
      loadingDialog: false,
      previewInfo: {}
    }
  },
  computed: {
    projectId () {
      return this.$route.params.projectId
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onSearch () {
      this.page = 1
      this.loadData()
    },
    loadData () {
      this.loading = true
      const time = this.searchInfo.dateRange && this.searchInfo.dateRange.length > 0
        ? {
            startTime: this.searchInfo.dateRange[0] || '',
            endTime: this.searchInfo.dateRange[1] || ''
          }
        : {}
      this.$axios.get(this.$apis.projectFile.selectYhProjectFilesByPage,
        {
          projectId: this.projectId,
          fileName: this.searchInfo.fileName,
          timeNode: this.searchInfo.timeNode,
          fileTypeId: this.searchInfo.fileTypeId,
          ...time,
          page: this.page,
          size: this.size
        }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    getTypeList () {
      this.searchInfo.fileTypeId = ''
      this.$axios.get(this.$apis.projectFile.selectYhProjectFileTypesByList, {
        timeNode: this.searchInfo.timeNode
      }).then(res => {
        this.typeList = res || []
      })
    },
    onPreview (item) {
      const file = item.fileList[0]
      if (file) {
        this.loadingDialog = true
        this.showPreview = true
        this.previewInfo = {
          title: file.fileName,
          previewUrl: location.origin + `/preview/onlinePreview?url=${encodeURIComponent(Base64.encode(file.filePrefix + file.fileUrl + '?fullfilename=' + file.fileName))}`
        }
        this.$nextTick(() => {
          this.$refs.iframe.addEventListener('load', () => {
            this.loadingDialog = false
          })
        })
      } else {
        this.$message.warning('请选择资料！')
      }
    },
    // 下载
    onDownload (row) {
      window.location.href = `${row.fileList[0].filePrefix + row.fileList[0].fileUrl}?attname=${row.fileList[0].fileName}`
    },
    onDelete (fileId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.projectFile.deleteYhProjectFiles, { fileId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  iframe {
    width: 100%;
    height: 600px;
  }
</style>
